import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';
import {
  orgSnowflakeDeclineUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';
import type { SnowflakeConnectionRequest } from '@/lib/portfolio/snowflake-types';

export function useDeclineSnowflakeRequest(orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (requestId: number) =>
      apiPost<SnowflakeConnectionRequest>(
        orgSnowflakeDeclineUrl(orgId, requestId),
        {}
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgSnowflakeRequests(orgId),
      });
    },
  });
}
